import { combineReducers } from 'redux'

import P from 'helpers/predicates'
import {
  CLEAR_PROJECT_INFO_DETAILS,
  UPDATE_PROJECT_INFO_ID,
  UPDATE_PROJECT_INFO_WORKFLOW_ID,
  UPDATE_PROJECT_INFO_DETAILS,
  UPDATE_REDIRECT,
} from './constants'
import {
  createReducer,
} from 'helpers/ReducerUtil'

const clearRedirect = () => false
const updateRedirect = (prev, { redirect }) => P.isNotNil(redirect)
  ? redirect
  : prev

const redirectSliceReducer = createReducer(false, {
  [UPDATE_REDIRECT]: updateRedirect,
})

// slices for each attribute
const projectIdSliceReducer = createReducer('', {
  [CLEAR_PROJECT_INFO_DETAILS]: () => '',
  [UPDATE_PROJECT_INFO_ID]: (state, action) => action.projectId
})

const workflowIdSliceReducer = createReducer('', {
  [CLEAR_PROJECT_INFO_DETAILS]: () => '',
  [UPDATE_PROJECT_INFO_WORKFLOW_ID]: (state, action) => action.workflowId
})

const productBrandReducer = createReducer('', {
  [CLEAR_PROJECT_INFO_DETAILS]: () => '',
  [UPDATE_PROJECT_INFO_DETAILS]: (brand, action) => action.brand
})

const productGpuSkuReducer = createReducer('', {
  [CLEAR_PROJECT_INFO_DETAILS]: () => '',
  [UPDATE_PROJECT_INFO_DETAILS]: (gpuSku, action) => action.gpuSku
})

const partnerSiteNameReducer = createReducer('', {
  [CLEAR_PROJECT_INFO_DETAILS]: () => '',
  [UPDATE_PROJECT_INFO_DETAILS]: (partnerSiteName, action) => action.partnerSiteName
})

const productSkuReducer = createReducer('', {
  [CLEAR_PROJECT_INFO_DETAILS]: () => '',
  [UPDATE_PROJECT_INFO_DETAILS]: (sku, action) => action.sku
})

const segmentSliceReducer = createReducer('', {
  [CLEAR_PROJECT_INFO_DETAILS]: () => '',
  [UPDATE_PROJECT_INFO_DETAILS]: (state, action) => action.segment
})

export const projectOverviewReducer = combineReducers({
  projectId: projectIdSliceReducer,
  workflowId: workflowIdSliceReducer,
  brand: productBrandReducer,
  gpuSku: productGpuSkuReducer,
  partnerSiteName: partnerSiteNameReducer,
  sku: productSkuReducer,
  segment: segmentSliceReducer,
  redirect: redirectSliceReducer
})
